export const config = {
    siteTitle: 'Stef van Dijk',
    titleSeperator: '|',
};
